<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1 maximum-scale=1">

<meta version="0.0.30" content="build:version">

<section class="hero-section">
    <div class="channel-html">
        <!--BEGIN > FIXED | HERO-->
        <div class="section theme-dark u02CAA2">
          <div class="section-content">
            <div class="row j29BAE3">
              <!---->
              <div class="column large-12 yC6984C">
                <div>
                  <!---->
                </div>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed fDD71ED">
                  <!---->
                  <div class="column sDC9BEE">
                    <div>
                      <!---->
                    </div>
                    <h2>
                      <picture class="picture">
                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 304px" srcset="assets/images/airPodsProImages/hero_logo_large_2x.png?600003f63a70 608w,assets/images/airPodsProImages/hero_logo_large.png?600003f9dce0 304w" type="image/png">
                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 244px" srcset="assets/images/airPodsProImages/hero_logo_medium_2x.png?600003f24b00 488w,assets/images/airPodsProImages/hero_logo_medium.png?600003f9a5d0 244w" type="image/png"><img sizes="135px" srcset="assets/images/airPodsProImages/hero_logo_small.png?600003fb3e90 135w,assets/images/airPodsProImages/hero_logo_small_2x.png?600003f9e520 270w" src="assets/images/airPodsProImages/hero_logo_small.png?600003fb3e90" alt="AirPods Pro 2" class="image gF3008B"></picture>
                    </h2>
                  </div>
                </div>
                <p class="copy q16D401 channel-custom-font-custom-80-headline-super" style="--focus-color: rgba(0, 125, 250, 0.6);">Groundbreaking sound.</p>
                <div>
                  <picture class="picture">
                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 470px" srcset="assets/images/airPodsProImages/hero_airpods_pro_2_large_2x.png?600003faf7b0 940w,assets/images/airPodsProImages/hero_airpods_pro_2_large.png?600003f9f4f0 470w" type="image/png">
                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 396px" srcset="assets/images/airPodsProImages/hero_airpods_pro_2_medium.png?600003f9e470 396w,assets/images/airPodsProImages/hero_airpods_pro_2_medium_2x.png?600003f9b440 792w" type="image/png"><img sizes="233px" srcset="assets/images/airPodsProImages/hero_airpods_pro_2_small_2x.png?600003fba890 466w,assets/images/airPodsProImages/hero_airpods_pro_2_small.png?600003fb3440 233w" src="assets/images/airPodsProImages/hero_airpods_pro_2_small_2x.png?600003fba890" alt="AirPods Pro 2 coming out of their charging case, green light on the front of the charging case" class="image double-invert k59757E"></picture>
                </div>
                <p class="copy helvetica-neue kC8EA74 channel-custom-font-custom-24-intro-elevated" style="--focus-color: rgba(0, 125, 250, 0.6);">AirPods Pro 2 — featuring pro-level Active Noise Cancellation, Adaptive Audio, Transparency mode, Personalised Spatial Audio and Loud Sound Reduction.</p>
  
                <p class="copy helvetica-neue s3A747E channel-custom-font-custom-17-partner-message" style="--focus-color: rgba(0, 125, 250, 0.6);">[Your Message]</p>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed o702B50">
                  <!---->
                  <div class="column large-12 c05F224">
                    <div>
                      <!---->
                    </div>
                    <!--BEGIN CHANNEL-BUTTON-->
                    <a href="#" aria-label="Buy, AirPods Pro 2" class="button button-custom button-base o830110" style="--focus-color: rgba(0, 113, 227, 100%);"> Buy </a>
                    <!--END CHANNEL-BUTTON-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FIXED | HERO-->
        <!--BEGIN > FIXED | BENTO -->
        <div class="section theme-dark i0CFACE">
          <div class="section-content">
            <div class="row k3CA21E">
              <!---->
              <div class="column large-12 x6FE9BB">
                <div>
                  <!---->
                </div>
                <ul role="list" aria-label="More reasons to love AirPods Pro 2" class="list qB144EC">
                  <li role="listitem" class="list-item eFA8F87">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed q9009B7">
                      <!---->
                      <div class="column large-12 mD56478">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box zBE9BB4">
                          <div class="bentobox-item s9184F6">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed u14F8BC">
                              <!---->
                              <div class="column large-12 n947452">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 980px" srcset="assets/images/airPodsProImages/features_bg_large.png?600003fa3020 980w,assets/images/airPodsProImages/features_bg_large_2x.png?600003fb30d0 1960w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 692px" srcset="assets/images/airPodsProImages/features_bg_medium_2x.png?600003fa7b20 1384w,assets/images/airPodsProImages/features_bg_medium.png?600003fb23c0 692w" type="image/png"><img sizes="320px" srcset="assets/images/airPodsProImages/features_bg_small_2x.png?600003f25ad0 640w,assets/images/airPodsProImages/features_bg_small.png?600003f10420 320w" src="assets/images/airPodsProImages/features_bg_small_2x.png?600003f25ad0" alt="" class="image g3DF025"></picture>
                                </div>
                                <div class="row large-display-bleed medium-display-bleed small-display-bleed o56AE0A">
                                  <!---->
                                  <div class="column large-12 y042264">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 192px" srcset="assets/images/airPodsProImages/features_anc_airpods_pro_2_large.png?600003fa2100 192w,assets/images/airPodsProImages/features_anc_airpods_pro_2_large_2x.png?600003f9c420 384w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 147px" srcset="assets/images/airPodsProImages/features_anc_airpods_pro_2_medium.png?600003f9a310 147w,assets/images/airPodsProImages/features_anc_airpods_pro_2_medium_2x.png?600003f34790 294w" type="image/png"><img sizes="142px" srcset="assets/images/airPodsProImages/features_anc_airpods_pro_2_small_2x.png?600003fb2890 284w,assets/images/airPodsProImages/features_anc_airpods_pro_2_small.png?600003f36aa0 142w" src="assets/images/airPodsProImages/features_anc_airpods_pro_2_small_2x.png?600003fb2890" alt="right AirPod with a silicone tip on it" class="image double-invert lCE75A2"></picture>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="column large-12 w3FCA9E">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy r7A124C channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">Unprecedented innovation. <br>Unparalleled sound.</p>
                                <div class="row large-display-bleed medium-display-bleed small-display-bleed zC27DDA">
                                  <!---->
                                  <div class="column large-4 small-12 fA99E14">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 35px" srcset="assets/images/airPodsProImages/person_closed_fill_large_2x.png?600003fbb650 70w,assets/images/airPodsProImages/person_closed_fill_large.png?600003fbbde0 35w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 25px" srcset="assets/images/airPodsProImages/person_closed_fill_medium.png?600003f9ed60 25w,assets/images/airPodsProImages/person_closed_fill_medium_2x.png?600003fa2940 50w" type="image/png"><img sizes="25px" srcset="assets/images/airPodsProImages/person_closed_fill_small.png?600003fa25d0 25w,assets/images/airPodsProImages/person_closed_fill_small_2x.png?600003f99290 50w" src="assets/images/airPodsProImages/person_closed_fill_small.png?600003fa25d0" alt="" class="image e0474E9"></picture>
                                    </div>
                                    <p class="copy helvetica-neue c3FA754 channel-custom-font-custom-14-fixed-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Pro‑level Active&nbsp;Noise&nbsp;Cancellation</span><br>Removes up to 2x unwanted sounds for immersive listening.<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 41px" srcset="assets/images/airPodsProImages/person_and_sparkles_fill_large_2x.png?600003fa3bd0 82w,assets/images/airPodsProImages/person_and_sparkles_fill_large.png?600003fbbbd0 41w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 28px" srcset="assets/images/airPodsProImages/person_and_sparkles_fill_medium_2x.png?600003fa7e90 56w,assets/images/airPodsProImages/person_and_sparkles_fill_medium.png?600003f98d10 28w" type="image/png"><img sizes="30px" srcset="assets/images/airPodsProImages/person_and_sparkles_fill_small.png?600003f2d130 30w,assets/images/airPodsProImages/person_and_sparkles_fill_small_2x.png?600003f361b0 60w" src="assets/images/airPodsProImages/person_and_sparkles_fill_small.png?600003f2d130" alt="" class="image m61DD5C"></picture>
                                    </div>
                                    <p class="copy helvetica-neue h4BD7C9 channel-custom-font-custom-14-fixed-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Adaptive&nbsp;Audio</span><br>Intelligently tailors noise control to your environment.<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                                  </div>
                                  <div class="column large-4 medium-5 small-12 yDA112D">
                                    <div>
                                      <!---->
                                    </div>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 35px" srcset="assets/images/airPodsProImages/person_open_fill_large.png?600003f06f70 35w,assets/images/airPodsProImages/person_open_fill_large_2x.png?600003f99ce0 70w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 25px" srcset="assets/images/airPodsProImages/person_open_fill_medium.png?600003f379c0 25w,assets/images/airPodsProImages/person_open_fill_medium_2x.png?600003f36100 50w" type="image/png"><img sizes="25px" srcset="assets/images/airPodsProImages/person_open_fill_small_2x.png?600003fa2470 50w,assets/images/airPodsProImages/person_open_fill_small.png?600003fb1ad0 25w" src="assets/images/airPodsProImages/person_open_fill_small_2x.png?600003fa2470" alt="" class="image i61D56C"></picture>
                                    </div>
                                    <p class="copy helvetica-neue v985A6A channel-custom-font-custom-14-fixed-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Transparency mode</span><br>Comfortably hear the world around you.<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></p>
                                    <div>
                                      <picture class="picture">
                                        <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 38px" srcset="assets/images/airPodsProImages/chip_h2_fill_large_2x.png?600003f99600 76w,assets/images/airPodsProImages/chip_h2_fill_large.png?600003fbb0d0 38w" type="image/png">
                                        <source media="(min-width: 735px)" sizes="(min-width: 735px) 28px" srcset="assets/images/airPodsProImages/chip_h2_fill_medium_2x.png?600003fa2730 56w,assets/images/airPodsProImages/chip_h2_fill_medium.png?600003fb2940 28w" type="image/png"><img sizes="28px" srcset="assets/images/airPodsProImages/chip_h2_fill_small_2x.png?600003fbb4f0 56w,assets/images/airPodsProImages/chip_h2_fill_small.png?600003fa3180 28w" src="assets/images/airPodsProImages/chip_h2_fill_small_2x.png?600003fbb4f0" alt="" class="image o9BF678"></picture>
                                    </div>
                                    <p class="copy helvetica-neue kABA114 channel-custom-font-custom-14-fixed-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Powered by the H2&nbsp;chip</span><br>The force driving advanced audio performance.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  
  
  
                  <li role="listitem" class="list-item j5BEC85">
    <div class="row large-display-bleed large-show medium-display-bleed medium-show small-display-bleed small-hide v9EFE6A">
      <!---->
      <div class="column large-12 k2466DE">
        <div>
          <!---->
        </div>
        <div class="bento-box z433B7F">
          <div class="bentobox-item c84C976">
            <!---->
            <div class="row medium-display-bleed small-display-bleed h02B568">
              <!---->
              <div class="column large-12 p810140">
                <div>
                  <!---->
                </div>
                <p class="copy j6229D4 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">Advanced hearing health features.</p>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed v029ED7">
              <!---->
              <div class="column large-6 large-offset-1 medium-6 gA83B24">
                <div>
                  <!---->
                </div>
                <ul role="list" aria-label="Hearing Health Features" class="list lBA8747">
                  <li role="listitem" class="list-item u573E3C">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed kBE02BA">
                      <!---->
                      <div class="column large-1 l8DB1D6">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 36px" srcset="assets/images/airPodsProImages/ear_badge_waveform_large.png?600003fb21b0 36w,assets/images/airPodsProImages/ear_badge_waveform_large_2x.png?600003f36ec0 72w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 26px" srcset="assets/images/airPodsProImages/ear_badge_waveform_medium.png?600003f35d90 26w,assets/images/airPodsProImages/ear_badge_waveform_medium_2x.png?600003fb18c0 52w" type="image/png"><img sizes="26px" srcset="assets/images/airPodsProImages/ear_badge_waveform_small_2x.png?600003fbb230 52w,assets/images/airPodsProImages/ear_badge_waveform_small.png?600003f9d760 26w" src="assets/images/airPodsProImages/ear_badge_waveform_small_2x.png?600003fbb230" alt="" class="image d358104"></picture>
                        </div>
                      </div>
                      <div class="column large-8 medium-9 i390D59">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue zAEB266 channel-custom-font-custom-17-fixed-body" style="--focus-color: rgba(0, 125, 250, 0.6);">Minimise your exposure to loud noise levels with <span style="color: #f5f5f7">Loud Sound Reduction</span>, use <span style="color: #f5f5f7">Conversation Boost</span> to focus on voices directly in front of you and play calming <span style="color: #f5f5f7">Background Sounds</span> — like ocean or rain — to mask unwanted environmental noise.</p>
                      </div>
                    </div>
                  </li>
                  
                </ul>
              </div>
              <div class="column large-5 h7AF3D1">
                <div>
                  <!---->
                </div>
                <div>
                  <picture class="picture">
                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 252px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_large.png?600003f9cbb0 252w,assets/images/airPodsProImages/hearing_iphone_airpods_large_2x.png?600003f9d080 504w" type="image/png">
                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 211px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_medium.png?600003f36050 211w,assets/images/airPodsProImages/hearing_iphone_airpods_medium_2x.png?600003f12cb0 422w" type="image/png"><img sizes="233px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_small.png?600003fa7bd0 233w,assets/images/airPodsProImages/hearing_iphone_airpods_small_2x.png?600003f63f40 466w" src="assets/images/airPodsProImages/hearing_iphone_airpods_small.png?600003fa7bd0" alt="AirPods Pro in charging case next to iPhone displaying a hearing health screen" class="image double-invert q43414B"></picture>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row large-display-bleed large-hide medium-display-bleed medium-hide small-display-bleed small-show vD816C3">
      <!---->
      <div class="column large-12 m541B99">
        <div>
          <!---->
        </div>
        <div class="bento-box f710D97">
          <div class="bentobox-item dF8D4E0">
            <!---->
            <div class="row medium-display-bleed small-display-bleed p71C344">
              <!---->
              <div class="column large-12 aAC1CC8">
                <div>
                  <!---->
                </div>
                <p class="copy jBACAF6 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">A breakthrough hearing health experience.</p>
                <div>
                  <picture class="picture">
                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 252px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_large.png?600003f9cbb0 252w,assets/images/airPodsProImages/hearing_iphone_airpods_large_2x.png?600003f9d080 504w" type="image/png">
                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 211px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_medium.png?600003f36050 211w,assets/images/airPodsProImages/hearing_iphone_airpods_medium_2x.png?600003f12cb0 422w" type="image/png"><img sizes="233px" srcset="assets/images/airPodsProImages/hearing_iphone_airpods_small.png?600003fa7bd0 233w,assets/images/airPodsProImages/hearing_iphone_airpods_small_2x.png?600003f63f40 466w" src="assets/images/airPodsProImages/hearing_iphone_airpods_small.png?600003fa7bd0" alt="AirPods Pro in charging case next to iPhone displaying a hearing health screen" class="image double-invert tBE9030"></picture>
                </div>
              </div>
              <div class="column large-12 t7548D7">
                <div>
                  <!---->
                </div>
                <ul role="list" aria-label="Hearing Health Features" class="list l4BFBD0">
                  
                  <li role="listitem" class="list-item p944249">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed b70B694">
                      <!---->
                      <div class="column large-1 i4D2680">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 34px" srcset="assets/images/airPodsProImages/ear_badge_waveform_large.png?600003fbaf70 34w,assets/images/airPodsProImages/ear_badge_waveform_large_2x.png?600003f99080 68w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 25px" srcset="assets/images/airPodsProImages/ear_badge_waveform_medium_2x.png?600003fba260 50w,assets/images/airPodsProImages/ear_badge_waveform_medium.png?600003fa7c80 25w" type="image/png"><img sizes="25px" srcset="assets/images/airPodsProImages/ear_badge_waveform_small.png?600003fa1970 25w,assets/images/airPodsProImages/ear_badge_waveform_small_2x.png?600003f99970 50w" src="assets/images/airPodsProImages/ear_badge_waveform_small.png?600003fa1970" alt="" class="image k2969C8"></picture>
                        </div>
                      </div>
                      <div class="column large-8 small-10 n8AE1AC">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue bDC639B channel-custom-font-custom-17-fixed-body" style="--focus-color: rgba(0, 125, 250, 0.6);">Minimise your exposure to loud noise levels with <span style="color: #f5f5f7">Loud Sound Reduction</span>, use <span style="color: #f5f5f7">Conversation Boost</span> to focus on voices directly in front of you and play calming <span style="color: #f5f5f7">Background Sounds</span> — like ocean or rain — to mask unwanted environmental noise.</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
  
  
  
  
  
  
                  <li role="listitem" class="list-item gD4FF40">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed p0CE575">
                      <!---->
                      <div class="column large-12 b49597C">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box w061D4C">
                          <div class="bentobox-item m583347">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed b0C74E7">
                              <!---->
                              <div class="column large-12 dC33925">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy c1AE776 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Four pairs of silicone tips</span> to fit a wide range of ear shapes.</p>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 653px" srcset="assets/images/airPodsProImages/silicone_tips_large.png?600003fff4f0 653w,assets/images/airPodsProImages/silicone_tips_large_2x.png?600003fff650 1306w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 463px" srcset="assets/images/airPodsProImages/silicone_tips_medium.png?600003fff5a0 463w,assets/images/airPodsProImages/silicone_tips_medium_2x.png?600003fff390 926w" type="image/png"><img sizes="233px" srcset="assets/images/airPodsProImages/silicone_tips_small.png?600003fff700 233w,assets/images/airPodsProImages/silicone_tips_small_2x.png?600003fff440 466w" src="assets/images/airPodsProImages/silicone_tips_small.png?600003fff700" alt="four silicone tips in different sizes, extra small, small, medium, large, right AirPod" class="image double-invert q8635CC"></picture>
                                </div>
                              </div>
                            </div>
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed mA2241C">
                              <!---->
                              <div class="column large-1 e81025F">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue n671F76 channel-custom-font-custom-14-tip-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span aria-hidden="true">XS</span></p>
                              </div>
                              <div class="column large-1 k54F2CD">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue j4DFBB8 channel-custom-font-custom-14-tip-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span aria-hidden="true">S</span></p>
                              </div>
                              <div class="column large-1 r2D7154">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue fCC2A47 channel-custom-font-custom-14-tip-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span aria-hidden="true">M</span></p>
                              </div>
                              <div class="column large-1 y2AEB27">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue b7A8888 channel-custom-font-custom-14-tip-caption" style="--focus-color: rgba(0, 125, 250, 0.6);"><span aria-hidden="true">L</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item j769232">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed nB9E560">
                      <!---->
                      <div class="column large-12 z1BF79F">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box fC1BA8F">
                          <div class="bentobox-item hD5B2A9">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed pA47D38">
                              <!---->
                              <div class="column large-12 b3325F1">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 980px" srcset="assets/images/airPodsProImages/spatial_audio_bg_large_2x.png?600003fb2f70 1960w,assets/images/airPodsProImages/spatial_audio_bg_large.png?600003fb39c0 980w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 692px" srcset="assets/images/airPodsProImages/spatial_audio_bg_medium.png?600003f9fa70 692w,assets/images/airPodsProImages/spatial_audio_bg_medium_2x.png?600003fa3d30 1384w" type="image/png"><img sizes="320px" srcset="assets/images/airPodsProImages/spatial_audio_bg_small.png?600003fa7f40 320w,assets/images/airPodsProImages/spatial_audio_bg_small_2x.png?600003fa2680 640w" src="assets/images/airPodsProImages/spatial_audio_bg_small.png?600003fa7f40" alt="A person dancing while wearing AirPods Pro" class="image double-invert b15DBB6"></picture>
                                </div>
                                <p class="copy xE04C52 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Personalised Spatial&nbsp;Audio.<sup aria-hidden="true">◊</sup><span class="visuallyhidden">Refer to legal disclaimers.</span></span> Sound fine‑tuned to you.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item fBF150D">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed gBBAA5C">
                      <!---->
                      <div class="column large-12 w60FFAC">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box b1D80F7">
                          <div class="bentobox-item f254B9D">
                            <!---->
                            <div class="row medium-display-bleed small-display-bleed y081C21">
                              <!---->
                              <div class="column large-12 jE45919">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy zBEFA7B channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">Power up with <span style="color: #f5f5f7">USB-C, MagSafe, Qi-certified or Apple Watch chargers.<sup aria-hidden="true">◊</sup><span class="visuallyhidden">Refer to legal disclaimers.</span></span></p>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 377px" srcset="assets/images/airPodsProImages/chargers_large_2x.png?600003fff860 754w,assets/images/airPodsProImages/chargers_large.png?600003fffb20 377w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 255px" srcset="assets/images/airPodsProImages/chargers_medium.png?600003fff7b0 255w,assets/images/airPodsProImages/chargers_medium_2x.png?600003fffa70 510w" type="image/png"><img sizes="274px" srcset="assets/images/airPodsProImages/chargers_small_2x.png?600003fff910 548w,assets/images/airPodsProImages/chargers_small.png?600003fff9c0 274w" src="assets/images/airPodsProImages/chargers_small_2x.png?600003fff910" alt="AirPods Pro 2 charging case above an Apple Watch charger" class="image double-invert p54B6D8"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item hFA0371">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed u32A92C">
                      <!---->
                      <div class="column large-12 wBF649B">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box i989339">
                          <div class="bentobox-item f7EA872">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed nC5A8EB">
                              <!---->
                              <div class="column large-12 l4C7404">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 118px" srcset="assets/images/airPodsProImages/bolt_circle_fill_large_2x.png?600003fbb7b0 236w,assets/images/airPodsProImages/bolt_circle_fill_large.png?600003fa2c00 118w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 118px" srcset="assets/images/airPodsProImages/bolt_circle_fill_medium_2x.png?600003fb2e10 236w,assets/images/airPodsProImages/bolt_circle_fill_medium.png?600003f9d3f0 118w" type="image/png"><img sizes="57px" srcset="assets/images/airPodsProImages/bolt_circle_fill_small_2x.png?600003fa3c80 114w,assets/images/airPodsProImages/bolt_circle_fill_small.png?600003f63e90 57w" src="assets/images/airPodsProImages/bolt_circle_fill_small_2x.png?600003fa3c80" alt="" class="image fAEA4E7"></picture>
                                </div>
                                <p class="copy r7652D9 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Up to 6 hours</span><br>of battery life with a single charge.<sup aria-hidden="true">◊</sup><span class="visuallyhidden">Refer to legal disclaimers.</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item q511330">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed f918B9E">
                      <!---->
                      <div class="column large-12 k4BAC55">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box a4AA5BE">
                          <div class="bentobox-item bC19474">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed jD1E8DB">
                              <!---->
                              <div class="column large-12 s1E1CE3">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 118px" srcset="assets/images/airPodsProImages/drop_circle_fill_large.png?600003fb1600 118w,assets/images/airPodsProImages/drop_circle_fill_large_2x.png?600003f9e940 236w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 118px" srcset="assets/images/airPodsProImages/drop_circle_fill_medium.png?600003f9aec0 118w,assets/images/airPodsProImages/drop_circle_fill_medium_2x.png?600003f63d30 236w" type="image/png"><img sizes="56px" srcset="assets/images/airPodsProImages/drop_circle_fill_small_2x.png?600003fbb020 112w,assets/images/airPodsProImages/drop_circle_fill_small.png?600003f9a680 56w" src="assets/images/airPodsProImages/drop_circle_fill_small_2x.png?600003fbb020" alt="" class="image e8D6A02"></picture>
                                </div>
                                <p class="copy q77507B channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);">IP54 dust, sweat and water resistant.<sup aria-hidden="true">◊</sup><span class="visuallyhidden">Refer to legal disclaimers.</span></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item s9670CA">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed i4B7998">
                      <!---->
                      <div class="column large-12 sC1078B">
                        <div>
                          <!---->
                        </div>
                        <div class="bento-box eA4033E">
                          <div class="bentobox-item d08903F">
                            <!---->
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed c2D7F32">
                              <!---->
                              <div class="column large-12 h528FFA">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy r78C615 channel-custom-font-custom-28-fixed-headline" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="color: #f5f5f7">Find&nbsp;My with Precision Finding</span> for your case, so you can locate it exactly.<sup aria-hidden="true">◊</sup><span class="visuallyhidden">Refer to legal disclaimers.</span></p>
                                <div>
                                  <picture class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 248px" srcset="assets/images/airPodsProImages/precision_finding_large_2x.png?600003fbb9c0 496w,assets/images/airPodsProImages/precision_finding_large.png?600003fb1a20 248w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 192px" srcset="assets/images/airPodsProImages/precision_finding_medium_2x.png?600003fa3b20 384w,assets/images/airPodsProImages/precision_finding_medium.png?600003fb1e40 192w" type="image/png"><img sizes="211px" srcset="assets/images/airPodsProImages/precision_finding_small_2x.png?600003f9b860 422w,assets/images/airPodsProImages/precision_finding_small.png?600003fb2260 211w" src="assets/images/airPodsProImages/precision_finding_small_2x.png?600003f9b860" alt="iPhone, displaying Find My for AirPods Pro" class="image double-invert f6EFC19"></picture>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!--END > FIXED | BENTO -->
        <!--BEGIN > FLEX | COMPARE-->
        <div class="section p829266">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed f8F57F7">
              <!---->
              <div class="column large-12 p8DE121">
                <div>
                  <!---->
                </div>
                <h2 class="copy gD415B9 channel-custom-font-custom-21-eyebrow-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Compare</h2>
                <h3 class="copy rE46FD1 channel-custom-font-custom-40-headline-reduced" style="--focus-color: rgba(0, 125, 250, 0.6);">Which AirPods are right for you?</h3>
              </div>
            </div>
            <div class="row large-display-bleed medium-display-bleed small-display-bleed g737104">
              <!---->
              <div class="zA722DE" style="--focus-color: rgba(0, 125, 250, 0.6);">
                <div data-export-class="channel-compare--hidden" data-channel-html-compare="{&quot;order&quot;:{&quot;small&quot;:[4,5,6,3],&quot;medium&quot;:[4,5,6,3],&quot;large&quot;:[3,4,5,6],&quot;max&quot;:{&quot;large&quot;:4,&quot;medium&quot;:3,&quot;small&quot;:2}},&quot;useStatic&quot;:false,&quot;isConfigurableCompare&quot;:false,&quot;selectorEls&quot;:&quot;[selector-dropdown]&quot;,&quot;labelEls&quot;:&quot;[compare-column-interactive]&quot;,&quot;swapEls&quot;:&quot;[data-column-group]&quot;,&quot;headerEl&quot;:&quot;[compare-header-row]&quot;,&quot;staticEl&quot;:&quot;[compare-column-header-static]&quot;}" class="channel-compare channel-compare--hidden">
                  <div class="section section-compare-table">
                    <div class="compare-wrapper">
                      <div role="table" aria-label="Compare models" class="compare compare-table with-fullwidthrowheader compare-column-range-large-4 compare-column-range-medium-3 compare-column-range-small-2">
                        <div>
                          <div role="rowgroup">
                            <div role="row" compare-header-row="" class="compare-row visuallyhidden">
                              <div role="columnheader">&nbsp;</div>
                              <div role="columnheader">AirPods 4</div>
                              <div role="columnheader">AirPods 4 with Active Noise Cancellation</div>
                              <div role="columnheader">AirPods Pro 2</div>
                              <div role="columnheader">AirPods Max</div>
                            </div>
                          </div>
                          <div role="rowgroup" class="compare selector-table with-fullwidthrowheader">
                            <div id="static-compare-header" role="row" data-column-group="" class="compare-row" style="display: none;">
                              <div role="rowheader" aria-rowspan="0" class="compare-rowheader" style="order: unset; visibility: hidden; display: none;">
                                <div class="visuallyhidden">Choose models to compare.</div>
                              </div>
                              <div id="hidden-columnheader" role="columnheader" class="visuallyhidden">&nbsp;</div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-0 first-child">
                                <div index="0">AirPods (2nd generation)</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-1">
                                <div index="1">AirPods (3rd generation) with Lightning Charging Case</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-2">
                                <div index="2">AirPods (3rd generation) with MagSafe Charging Case</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-3">
                                <div index="3">AirPods 4</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-4">
                                <div index="4">AirPods 4 with Active Noise Cancellation</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-5">
                                <div index="5">AirPods Pro 2</div>
                              </div>
                              <div role="columnheader" compare-column-header-static="" class="static-dropdown compare-column compare-static-6">
                                <div index="6">AirPods Max</div>
                              </div>
                            </div>
                            <div id="interactive-compare-header" role="row" class="compare-row">
                              <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                                <div class="visuallyhidden">Choose models to compare.</div>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-0  first-child">
                                <form autocomplete="off" class="selector-element"><label for="0" class="visuallyhidden">Select a model</label><select id="0" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="In-ear models">
                                      <option value="0">AirPods (2nd generation)</option>
                                      <option value="1">AirPods (3rd generation) with Lightning Charging Case</option>
                                      <option value="2">AirPods (3rd generation) with MagSafe Charging Case</option>
                                      <option value="3" aria-selected="true" selected="true">AirPods 4</option>
                                      <option value="4">AirPods 4 with Active Noise Cancellation</option>
                                      <option value="5">AirPods Pro 2</option>
                                      <!---->
                                    </optgroup>
                                    <optgroup label="Over-ear models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="6">AirPods Max</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-1 ">
                                <form autocomplete="off" class="selector-element"><label for="1" class="visuallyhidden">Select a model</label><select id="1" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="In-ear models">
                                      <option value="0">AirPods (2nd generation)</option>
                                      <option value="1">AirPods (3rd generation) with Lightning Charging Case</option>
                                      <option value="2">AirPods (3rd generation) with MagSafe Charging Case</option>
                                      <option value="3">AirPods 4</option>
                                      <option value="4" aria-selected="true" selected="true">AirPods 4 with Active Noise Cancellation</option>
                                      <option value="5">AirPods Pro 2</option>
                                      <!---->
                                    </optgroup>
                                    <optgroup label="Over-ear models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="6">AirPods Max</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-2 ">
                                <form autocomplete="off" class="selector-element"><label for="2" class="visuallyhidden">Select a model</label><select id="2" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="In-ear models">
                                      <option value="0">AirPods (2nd generation)</option>
                                      <option value="1">AirPods (3rd generation) with Lightning Charging Case</option>
                                      <option value="2">AirPods (3rd generation) with MagSafe Charging Case</option>
                                      <option value="3">AirPods 4</option>
                                      <option value="4">AirPods 4 with Active Noise Cancellation</option>
                                      <option value="5" aria-selected="true" selected="true">AirPods Pro 2</option>
                                      <!---->
                                    </optgroup>
                                    <optgroup label="Over-ear models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="6">AirPods Max</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <div role="cell" compare-column-interactive="true" class="compare-column-interactive compare-column compare-column-3 ">
                                <form autocomplete="off" class="selector-element"><label for="3" class="visuallyhidden">Select a model</label><select id="3" selector-dropdown="true" class="selector-dropdown">
                                    <optgroup label="In-ear models">
                                      <option value="0">AirPods (2nd generation)</option>
                                      <option value="1">AirPods (3rd generation) with Lightning Charging Case</option>
                                      <option value="2">AirPods (3rd generation) with MagSafe Charging Case</option>
                                      <option value="3">AirPods 4</option>
                                      <option value="4">AirPods 4 with Active Noise Cancellation</option>
                                      <option value="5">AirPods Pro 2</option>
                                      <!---->
                                    </optgroup>
                                    <optgroup label="Over-ear models">
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <!---->
                                      <option value="6" aria-selected="true" selected="true">AirPods Max</option>
                                    </optgroup>
                                  </select><span aria-hidden="true" class="selector-icon icon icon-chevrondown"></span></form>
                              </div>
                              <!---->
                              <!---->
                              <!---->
                            </div>
                          </div>
                        </div>
                        <!--BEGIN > CATEGORY > IMAGES-->
                        <div role="rowgroup" class="compare-section section-images no-padding-top">
                          <!--BEGIN > CATEGORY > IMAGES > FEATURE > IMAGES-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-embeded-image">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Images</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div class="y3A9FA4 embed-image" index="0">
                                <figure role="img" aria-label="AirPods (2nd generation)" class="compare-image image-compare_airpods_2_h1"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div class="a1E3943 embed-image" index="1">
                                <figure role="img" aria-label="AirPods (3rd generation) with Lightning Charging Case" class="compare-image image-compare_airpods_3_lightning_h1"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div class="bA77847 embed-image" index="2">
                                <figure role="img" aria-label="AirPods (3rd generation) with MagSafe Charging Case" class="compare-image image-compare_airpods_3_lightning_h1"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div class="bC858B0 embed-image" index="3">
                                <figure role="img" aria-label="AirPods 4" class="compare-image image-compare_airpods_4_h2"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div class="e9375F0 embed-image" index="4">
                                <figure role="img" aria-label="AirPods 4 with Active Noise Cancellation" class="compare-image image-compare_airpods_4_active_noise_cancellation_h2"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div class="b25C215 embed-image" index="5">
                                <figure role="img" aria-label="AirPods Pro 2" class="compare-image image-compare_airpods_pro_2_h2"></figure>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div class="bD61658 embed-image" index="6">
                                <figure role="img" aria-label="AirPods Max" class="compare-image image-compare_airpods_max_h1"></figure>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > IMAGES > FEATURE > IMAGES-->
                        </div>
                        <!--END > CATEGORY > IMAGES-->
                        <!--BEGIN > CATEGORY > FINISH-->
                        <div role="rowgroup" class="compare-section section-finish no-padding-top">
                          <!--BEGIN > CATEGORY > FINISH > FEATURE > COLOR-NAV-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-color-nav">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Finish</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div product-name="AirPods (2nd generation)" class="row-colors" index="0">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods (2nd generation), Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div product-name="AirPods (3rd generation) with Lightning Charging Case" class="row-colors" index="1">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods (3rd generation) with Lightning Charging Case, Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div product-name="AirPods (3rd generation) with MagSafe Charging Case" class="row-colors" index="2">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods (3rd generation) with MagSafe Charging Case, Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div product-name="AirPods 4" class="row-colors" index="3">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods 4, Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div product-name="AirPods 4 with Active Noise Cancellation" class="row-colors" index="4">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods 4 with Active Noise Cancellation, Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div product-name="AirPods Pro 2" class="row-colors" index="5">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods Pro 2, Available in White" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="White" class="colornav-swatch" style="background-color: rgb(240, 241, 245);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">White</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div product-name="AirPods Max" class="row-colors" index="6">
                                <!---->
                                <div>
                                  <div role="list" aria-label="AirPods Max, Available in Midnight, Starlight, Blue, Purple, Orange" class="colornav-items">
                                    <div class="colornav-item-row">
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Midnight" class="colornav-swatch" style="background-color: rgb(42, 49, 56);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Starlight" class="colornav-swatch" style="background-color: rgb(204, 191, 178);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Blue" class="colornav-swatch" style="background-color: rgb(145, 169, 181);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Purple" class="colornav-swatch" style="background-color: rgb(175, 166, 188);"></figure>
                                      </div>
                                      <div role="listitem" class="colornav-item">
                                        <figure role="img" aria-label="Orange" class="colornav-swatch" style="background-color: rgb(227, 164, 141);"></figure>
                                      </div>
                                    </div>
                                    <!---->
                                  </div>
                                  <div class="colornav-label-container">
                                    <p class="channel-colornav-label copy">Midnight, Starlight, Blue, Purple, Orange</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > FINISH > FEATURE > COLOR-NAV-->
                        </div>
                        <!--END > CATEGORY > FINISH-->
                        <!--BEGIN > CATEGORY > BUY-->
                        <div role="rowgroup" class="compare-section section-buy no-padding-top">
                          <!--BEGIN > CATEGORY > BUY > FEATURE > BUY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-border-top compare-template-preview-item-default">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Buy</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div class="button-container" index="0" product-name="AirPods (2nd generation)"><a id="AirPods (2nd generation)" href="#" aria-label="Buy AirPods (2nd generation)" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div class="button-container" index="1" product-name="AirPods (3rd generation) with Lightning Charging Case"><a id="AirPods (3rd generation) with Lightning Charging Case" href="#" aria-label="Buy AirPods (3rd generation) with Lightning Charging Case" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div class="button-container" index="2" product-name="AirPods (3rd generation) with MagSafe Charging Case"><a id="AirPods (3rd generation) with MagSafe Charging Case" href="#" aria-label="Buy AirPods (3rd generation) with MagSafe Charging Case" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div class="button-container" index="3" product-name="AirPods 4"><a id="AirPods 4" href="#" aria-label="Buy AirPods 4" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div class="button-container" index="4" product-name="AirPods 4 with Active Noise Cancellation"><a id="AirPods 4 with Active Noise Cancellation" href="#" aria-label="Buy AirPods 4 with Active Noise Cancellation" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div class="button-container" index="5" product-name="AirPods Pro 2"><a id="AirPods Pro 2" href="#" aria-label="Buy AirPods Pro 2" class="button compare-button">Buy</a></div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div class="button-container" index="6" product-name="AirPods Max"><a id="AirPods Max" href="#" aria-label="Buy AirPods Max" class="button compare-button">Buy</a></div>
                            </div>
                          </div>
                          <!--END > CATEGORY > BUY > FEATURE > BUY-->
                        </div>
                        <!--END > CATEGORY > BUY-->
                        <!--BEGIN > CATEGORY > QUICK-LOOK-->
                        <div role="rowgroup" class="compare-section section-quick-look no-padding-top multi-row">
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > ACTIVE-NOISE-CANCELLATION-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Quick look</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat mdash-container copy" index="0">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat mdash-container copy" index="1">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat mdash-container copy" index="2">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat mdash-container copy" index="3">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper v9FD6D4 embed-image">
                                      <figure class="compare-image image-icon_person_closed_and_sparkles_and_open_fill_base"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 80px;">
                                    <!----><span class="stat-caption copy">Active Noise Cancellation, Adaptive Audio and Transparency mode<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zC55BB2 embed-image">
                                      <figure class="compare-image image-icon_person_closed_and_sparkles_and_open_fill_base"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 80px;">
                                    <!----><span class="stat-caption copy">Up to 2x more Active&nbsp;Noise Cancellation,<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span> with Adaptive&nbsp;Audio and Transparency&nbsp;mode<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t1AD200 embed-image">
                                      <figure class="compare-image image-icon_person_closed_and_open_fill_base"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 80px;">
                                    <!----><span class="stat-caption copy">Up to 2x more Active&nbsp;Noise Cancellation,<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span> with Transparency&nbsp;mode</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > ACTIVE-NOISE-CANCELLATION-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CONVERSATION-AWARENESS-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Conversation Awareness</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat mdash-container copy" index="0">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat mdash-container copy" index="1">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat mdash-container copy" index="2">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat mdash-container copy" index="3">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper yE58E20 embed-image">
                                      <figure class="compare-image image-icon_person_wave2_fill_base"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Conversation Awareness<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y99E40D embed-image">
                                      <figure class="compare-image image-icon_person_wave2_fill_base"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Conversation Awareness<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat mdash-container copy" index="6">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CONVERSATION-AWARENESS-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > HEARING-ASSISTANCE-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Hearing Assistance</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat mdash-container copy" index="0">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat mdash-container copy" index="1">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat mdash-container copy" index="2">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat mdash-container copy" index="3">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat mdash-container copy" index="4">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            
  
  
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat mdash-container copy" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper g60F1FA embed-image">
                                      <figure class="compare-image image-icon_ear_stat_waveform_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 84px;">
                                    <!----><span class="stat-caption copy">Loud Sound Reduction, Conversation Boost and Background Sounds</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
  
  
  
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat mdash-container copy" index="6">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > HEARING-ASSISTANCE-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > Personalised-SPATIAL-AUDIO-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Personalised Spatial Audio</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat mdash-container copy" index="0">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper zF0D73A embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper xC8CAAD embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper d9C0B3C embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p6071B9 embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper z5BBAFA embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper iD7AA49 embed-image">
                                      <figure class="compare-image image-icon_person_spatialaudio_fill_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Personalised Spatial&nbsp;Audio with dynamic head tracking<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > Personalised-SPATIAL-AUDIO-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > DURABILITY-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Durability</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat mdash-container copy" index="0">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eD7AF9A embed-image">
                                      <figure class="compare-image image-icon_drop_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Sweat and water resistant<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s7ABEEF embed-image">
                                      <figure class="compare-image image-icon_drop_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Sweat and water resistant<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper e2D47CE embed-image">
                                      <figure class="compare-image image-icon_drop_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Dust, sweat and water resistant (IP54)<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pC58057 embed-image">
                                      <figure class="compare-image image-icon_drop_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Dust, sweat and water resistant (IP54)<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper k9A867F embed-image">
                                      <figure class="compare-image image-icon_drop_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">Dust, sweat and water resistant (IP54)<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat mdash-container copy" index="6">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > DURABILITY-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CHARGING-CASE-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Charging Case</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper oEFE5EE embed-image">
                                      <figure class="compare-image image-icon_airpods_chargingcase_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning Charging Case</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p72A7F9 embed-image">
                                      <figure class="compare-image image-icon_airpods_chargingcase_wireless_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Lightning Charging Case</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n79562A embed-image">
                                      <figure class="compare-image image-icon_airpods_chargingcase_wireless_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">MagSafe&nbsp;Charging Case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper p6D521E embed-image">
                                      <figure class="compare-image image-icon_airpods_chargingcase_wireless_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 96px;">
                                    <!----><span class="stat-caption copy">Charging Case (USB-C)<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper o7FBF05 embed-image">
                                      <figure class="compare-image image-icon_airpods_chargingcase_wireless_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 96px;">
                                    <!----><span class="stat-caption copy">Wireless Charging Case (USB-C) works with Apple Watch charger and Qi-certified chargers;<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span> includes speaker for Find&nbsp;My<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper x28E104 embed-image">
                                      <figure class="compare-image image-icon_airpodspro_chargingcase_wireless_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 96px;">
                                    <!----><span class="stat-caption copy">MagSafe Charging Case (USB-C) works with Apple Watch charger and Qi-certified chargers;<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span> includes lanyard loop and speaker for Find&nbsp;My<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n724FFD embed-image">
                                      <figure class="compare-image image-icon_airpodsmax_case_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 96px;">
                                    <!----><span class="stat-caption copy">Smart&nbsp;Case</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CHARGING-CASE-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-LIFE-LISTENING-TIME-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Battery Life: Listening Time</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">5 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 5 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">6 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 6 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">6 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 6 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">5 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 5 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">5 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 5 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">6 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 6 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <!----><span class="stat-value">20 hours</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 20 hours of listening time on one&nbsp;charge<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-LIFE-LISTENING-TIME-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-LIFE-TOTAL-LISTENING-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Battery Life: Total Listening</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w6E0F7D embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">More than 24 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper v39DC09 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 30 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper hFB73EC embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Up to 30 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper x729E0D embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 30 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w32FC09 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 30 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper f7BA131 embed-image">
                                      <figure class="compare-image image-icon_battery_100percent_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 48px;">
                                    <!----><span class="stat-caption copy">Up to 30 hours of listening time with charging case<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat mdash-container copy" index="6">
                                <div class="stat-content"><span class="stat-caption"><p aria-hidden="true" class="mdash stat-caption">—</p><p class="visuallyhidden">Not Applicable</p></span></div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > BATTERY-LIFE-TOTAL-LISTENING-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CONTROL-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Control</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r7C6687 embed-image">
                                      <figure class="compare-image image-icon_hand_point_up_left_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Double-tap</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s1595D4 embed-image">
                                      <figure class="compare-image image-icon_hand_tap_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Force sensor</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper y07E121 embed-image">
                                      <figure class="compare-image image-icon_hand_tap_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Force sensor</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper xB2D753 embed-image">
                                      <figure class="compare-image image-icon_hand_tap_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Force sensor</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper pECE458 embed-image">
                                      <figure class="compare-image image-icon_hand_tap_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Force sensor</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper sDBC45A embed-image">
                                      <figure class="compare-image image-icon_hand_draw_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Touch control</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper v8E8513 embed-image">
                                      <figure class="compare-image image-icon_digitalcrown_horizontal_arrow_clockwise_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Digital&nbsp;Crown</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CONTROL-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > CHIP-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Chip</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper u040DE6 embed-image">
                                      <figure class="compare-image image-icon_chip_h1_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">H1 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper m5D3C3C embed-image">
                                      <figure class="compare-image image-icon_chip_h1_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">H1 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s5F024A embed-image">
                                      <figure class="compare-image image-icon_chip_h1_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">H1 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper n974B96 embed-image">
                                      <figure class="compare-image image-icon_chip_h2_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">H2 chip with Voice&nbsp;Isolation<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper eB49D4D embed-image">
                                      <figure class="compare-image image-icon_chip_h2_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">H2 chip with Voice&nbsp;Isolation<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r61BE7E embed-image">
                                      <figure class="compare-image image-icon_chip_h2_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">H2 chip with Voice&nbsp;Isolation<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper w7F4169 embed-image">
                                      <figure class="compare-image image-icon_chip_h1_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">H1 chip</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > CHIP-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > SIRI-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Siri</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper s998628 embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">“Hey Siri”</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper nC7F8D7 embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">“Hey Siri”</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper gA4200B embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">“Hey Siri”</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper jFCBFB6 embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">“Hey Siri” and Siri Interactions<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper r590DCE embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">“Hey Siri” and Siri Interactions<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper lEAB36E embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">“Hey Siri” and Siri Interactions<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper a84250E embed-image">
                                      <figure class="compare-image image-icon_siri_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 32px;">
                                    <!----><span class="stat-caption copy">“Hey Siri”</span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > SIRI-->
                          <!--BEGIN > CATEGORY > QUICK-LOOK > FEATURE > AUTOMATIC-SWITCHING-->
                          <div role="row" data-column-group="" class="compare-row compare-template-preview-item-stat">
                            <div role="rowheader" aria-rowspan="0" class="compare-rowheader">
                              <div class="visuallyhidden">Automatic Switching</div>
                            </div>
                            <div role="cell" class="first-child compare-column product-0">
                              <div role="presentation" class="stat" index="0">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper fEFBF54 embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-1">
                              <div role="presentation" class="stat" index="1">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper tE05245 embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-2">
                              <div role="presentation" class="stat" index="2">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper h3158F7 embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-3 compare-column-0">
                              <div role="presentation" class="stat" index="3">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper t3CC905 embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-4 compare-column-1">
                              <div role="presentation" class="stat" index="4">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper mB5FF0A embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-5 compare-column-2">
                              <div role="presentation" class="stat" index="5">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper c453B27 embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div role="cell" class="compare-column product-6 compare-column-3">
                              <div role="presentation" class="stat" index="6">
                                <div class="stat-content">
                                  <div class="stat-row">
                                    <div aria-hidden="true" class="image-icon-wrapper q7A1DFF embed-image">
                                      <figure class="compare-image image-icon_macbook_and_iphone_elevated"></figure>
                                    </div>
                                    <!---->
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                  <div class="stat-row" style="height: 16px;">
                                    <!----><span class="stat-caption copy">Automatic Switching<span aria-hidden="true" style="top: -0.3em; position: relative; font-size: 10px;vertical-align: top;">◊</span><span class="visuallyhidden" style="white-space: nowrap;">Refer to legal disclaimers</span></span>
                                    <!---->
                                    <!---->
                                    <!---->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--END > CATEGORY > QUICK-LOOK > FEATURE > AUTOMATIC-SWITCHING-->
                        </div>
                        <!--END > CATEGORY > QUICK-LOOK-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | COMPARE-->
        <!--BEGIN > FLEX | COMPATIBILITY-->
        <div class="section theme-light b906BC2">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed small-display-bleed wADE9DB">
              <!---->
              <div class="column large-12 i65F886">
                <div>
                  <!---->
                </div>
                <div class="bento-box gF22EF5">
                  <div class="bentobox-item iD5ED5B">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed nB76006">
                      <!---->
                      <div class="column large-5 medium-6 small-12 x953B89">
                        <div>
                          <!---->
                        </div>
                        <h2 class="copy sDA9348 channel-custom-font-custom-21-eyebrow-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Compatibility</h2>
                        <p class="copy f7A981F channel-custom-font-custom-40-headline-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Magic runs <br> in the family.</p>
                        <p class="copy helvetica-neue o8AA0E0 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">AirPods work seamlessly with iPhone, iMac, iPad, Apple Watch and more. And every model packs rich, high-fidelity audio into an innovative wireless design.</p>
                      </div>
                      <div class="column large-7 medium-6 small-12 e093854">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 276px" srcset="assets/images/airPodsProImages/flex_compatibility_large.png?600003fa23c0 276w,assets/images/airPodsProImages/flex_compatibility_large_2x.png?600003f2cb00 552w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 225px" srcset="assets/images/airPodsProImages/flex_compatibility_medium.png?600003fa7910 225w,assets/images/airPodsProImages/flex_compatibility_medium_2x.png?600003f37d30 450w" type="image/png"><img sizes="239px" srcset="assets/images/airPodsProImages/flex_compatibility_small.png?600003f98c60 239w,assets/images/airPodsProImages/flex_compatibility_small_2x.png?600003fa1810 478w" src="assets/images/airPodsProImages/flex_compatibility_small.png?600003f98c60" alt="iPhone next to AirPods Pro in charging case, case is open" class="image double-invert h56212A"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | COMPATIBILITY-->
        <!--BEGIN > FLEX | APPLECARE+ -->
        <div class="section theme-light c210B41">
          <div class="section-content">
            <div class="row large-display-bleed small-display-bleed e7E9BCA">
              <!---->
              <div class="column large-12 h93FB9B">
                <div>
                  <!---->
                </div>
                <div class="bento-box s8AA1EB">
                  <div class="bentobox-item yAECA6C">
                    <!---->
                    <div class="row large-display-bleed medium-display-bleed k53B687">
                      <!---->
                      <div class="column large-5 medium-6 small-12 oE7801C">
                        <div>
                          <!---->
                        </div>
                        <h2>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 57px" srcset="assets/images/airPodsProImages/flex_applecare_chiclet_large_2x.png?600003f9a050 114w,assets/images/airPodsProImages/flex_applecare_chiclet_large.png?600003fb2520 57w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 57px" srcset="assets/images/airPodsProImages/flex_applecare_chiclet_medium.png?600003fa7a70 57w,assets/images/airPodsProImages/flex_applecare_chiclet_medium_2x.png?600003f63bd0 114w" type="image/png"><img sizes="57px" srcset="assets/images/airPodsProImages/flex_applecare_chiclet_small.png?600003fa1ef0 57w,assets/images/airPodsProImages/flex_applecare_chiclet_small_2x.png?600003f37700 114w" src="assets/images/airPodsProImages/flex_applecare_chiclet_small.png?600003fa1ef0" alt="AppleCare+ badge" class="image j9E4370"></picture>
                        </h2>
                        <p class="copy q7D5BA9 channel-custom-font-custom-40-headline-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Expert support, enhanced coverage.</p>
                        <ul role="list" aria-label="Apple care plus support and coverage" class="list q7FB669">
                          <li role="listitem" class="list-item aA9DD07">
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed r40F3C5">
                              <!---->
                              <div class="column iFE716E">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture aria-hidden="true" class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_large_2x.png?600003fa1d90 30w,assets/images/airPodsProImages/check_d0112b_34_R_large.png?600003fa3de0 15w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_medium.png?600003fa18c0 15w,assets/images/airPodsProImages/check_d0112b_34_R_medium_2x.png?600003fa79c0 30w" type="image/png"><img sizes="15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80 30w,assets/images/airPodsProImages/check_d0112b_34_R_small.png?600003fa2890 15w" src="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80" alt="" class="image c8BF5A0"></picture>
                                </div>
                              </div>
                              <div class="column medium-11 small-10 a82985D">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue b66DCE7 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Apple-certified service</p>
                              </div>
                            </div>
                          </li>
                          <li role="listitem" class="list-item lFBB18F">
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed cBCB2B4">
                              <!---->
                              <div class="column sE2668F">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture aria-hidden="true" class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_large_2x.png?600003fa1d90 30w,assets/images/airPodsProImages/check_d0112b_34_R_large.png?600003fa3de0 15w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_medium.png?600003fa18c0 15w,assets/images/airPodsProImages/check_d0112b_34_R_medium_2x.png?600003fa79c0 30w" type="image/png"><img sizes="15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80 30w,assets/images/airPodsProImages/check_d0112b_34_R_small.png?600003fa2890 15w" src="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80" alt="" class="image n29AF10"></picture>
                                </div>
                              </div>
                              <div class="column large-11 medium-11 small-10 g2DAD24">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue dE3B6E8 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Priority access to Apple experts</p>
                              </div>
                            </div>
                          </li>
                          <li role="listitem" class="list-item c1968D7">
                            <div class="row large-display-bleed medium-display-bleed small-display-bleed j96E8A3">
                              <!---->
                              <div class="column s75AA1E">
                                <div>
                                  <!---->
                                </div>
                                <div>
                                  <picture aria-hidden="true" class="picture">
                                    <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_large_2x.png?600003fa1d90 30w,assets/images/airPodsProImages/check_d0112b_34_R_large.png?600003fa3de0 15w" type="image/png">
                                    <source media="(min-width: 735px)" sizes="(min-width: 735px) 15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_medium.png?600003fa18c0 15w,assets/images/airPodsProImages/check_d0112b_34_R_medium_2x.png?600003fa79c0 30w" type="image/png"><img sizes="15px" srcset="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80 30w,assets/images/airPodsProImages/check_d0112b_34_R_small.png?600003fa2890 15w" src="assets/images/airPodsProImages/check_d0112b_34_R_small_2x.png?600003fa1b80" alt="" class="image w4C564B"></picture>
                                </div>
                              </div>
                              <div class="column medium-11 small-10 a818DDC">
                                <div>
                                  <!---->
                                </div>
                                <p class="copy helvetica-neue u1AB385 channel-custom-font-custom-17-body-reduced-flex" style="--focus-color: rgba(0, 125, 250, 0.6);">Accidental damage coverage</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <div class="row large-display-bleed medium-display-bleed small-display-bleed vA1F00B">
                          <!---->
                          <div class="column large-12 sBC342D">
                            <div>
                              <!---->
                            </div><a href="#" class="link-wrapper link-standalone s027292" style="--focus-color: rgba(0, 125, 250, 0.6);"><span class="cD7E91E icon icon-chevronright icon-after channel-custom-font-custom-17-links"><span>Learn more about AppleCare+ for AirPods</span></span></a>
                          </div>
                        </div>
                      </div>
                      <div class="column large-6 medium-5 small-12 v1962B5">
                        <div>
                          <!---->
                        </div>
                        <div>
                          <picture class="picture">
                            <source media="(min-width: 1069px)" sizes="(min-width: 1069px) 365px" srcset="assets/images/airPodsProImages/flex_applecare_large.png?600003f9a940 365w,assets/images/airPodsProImages/flex_applecare_large_2x.png?600003f2cbb0 730w" type="image/png">
                            <source media="(min-width: 735px)" sizes="(min-width: 735px) 225px" srcset="assets/images/airPodsProImages/flex_applecare_medium.png?600003fa2d60 225w,assets/images/airPodsProImages/flex_applecare_medium_2x.png?600003f98f20 450w" type="image/png"><img sizes="236px" srcset="assets/images/airPodsProImages/flex_applecare_small_2x.png?600003fb16b0 472w,assets/images/airPodsProImages/flex_applecare_small.png?600003f374f0 236w" src="assets/images/airPodsProImages/flex_applecare_small_2x.png?600003fb16b0" alt="Front view of AirPods Pro shown outside of case" class="image double-invert k492C70"></picture>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--END > FLEX | APPLECARE+ -->
        <!--BEGIN > LEGAL-->
        <div class="section e9DA4B1">
          <div class="section-content">
            <div class="row large-display-bleed medium-display-bleed u892C6B">
              <!---->
              <aside aria-labelledby="comp" role="complimentary" class="column large-12 medium-12 v25EAC1">
                <div>
                  <!---->
                </div>
                <div class="row large-display-bleed medium-display-bleed small-display-bleed tF70703">
                  <!---->
                  <div class="column large-12 qDE861B">
                    <div>
                      <!---->
                    </div>
                    <h2 id="comp" class="copy helvetica-neue h2730B5 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span id="footnote-diamond-1" aria-hidden="true">◊</span>Legal Disclaimers</h2>
                  </div>
                </div>
                <ul role="list" class="list kF05A0E">
                  <li role="listitem" class="list-item e7C7012">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed l8BB135">
                      <!---->
                      <div class="column large-12 f8B5651">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue c912E39 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Active Noise Cancellation, Adaptive Audio and Transparency Mode:</span> Device performance and noise control features like Active Noise Cancellation, Adaptive Audio and Transparency mode can be affected by debris or earwax build-up. Clean the device regularly to maintain performance and full feature functionality. Refer to <a href="https://support.apple.com/en-in/102672" class="footer-link"><span style="color: #424245; white-space: nowrap;">support.apple.com/en-in/102672</span></a> for AirPods 4 cleaning instructions. Refer to <a href="https://support.apple.com/en-in/120409" class="footer-link"><span style="color: #424245; white-space: nowrap;">support.apple.com/en-in/120409</span></a> for AirPods Pro 2 cleaning instructions.</p>
  
                             
  
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item jA252A3">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed o298C04">
                      <!---->
                      <div class="column large-12 l780AEE">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue s84A641 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Up to 2x More Active Noise Cancellation:</span> Up to 2x more Active Noise Cancellation compared with AirPods Pro (1st generation) and AirPods 4 with Active Noise Cancellation.</p>
  
  
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item n88D6F7">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed dE52723">
                      <!---->
                      <div class="column large-12 mF47283">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue a6746CD channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Adaptive Audio:</span> Available on compatible devices with the latest operating system software when paired with AirPods 4 with Active Noise Cancellation or AirPods Pro 2 with the latest firmware.</p>
  
                      </div>
                    </div>
                  </li>
                  
                  <li role="listitem" class="list-item xF333AB">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed y6B640C">
                      <!---->
                      <div class="column large-12 fB5E580">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue sB92A61 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Personalised Spatial Audio:</span> Compatible hardware and software are required. Works with compatible content in supported apps. Not all content is available in Dolby Atmos. iPhone with TrueDepth camera is required to create a personal profile for Spatial Audio, which will sync across Apple devices running the latest operating system software, including iOS, iPadOS, macOS and tvOS.</p>
  
                        
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item p51F94A">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed qDF9A80">
                      <!---->
                      <div class="column large-12 jECFFBA">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue uA2DE86 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Charging:</span> USB-C charging requires a compatible USB-C charger. Wireless charging requires a Qi-certified wireless charger. MagSafe charging requires a compatible MagSafe charger. AirPods 4 with Active Noise Cancellation and AirPods Pro 2 charging cases also work with the Apple Watch charger.</p>
  
  
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item gF91E38">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed f133153">
                      <!---->
                      <div class="column large-12 rE2179D">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue aE50ADA channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Battery:</span> Battery life depends on device settings, environment, usage and many other factors. Testing conducted on AirPods 4 with Active Noise Cancellation with noise control off.</p>
  
  
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item w38661D">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed fD5FF03">
                      <!---->
                      <div class="column large-12 vB76A4A">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue o3F3481 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Dust, Sweat and Water Resistance:</span> AirPods 4, AirPods 4 with Active Noise Cancellation and AirPods Pro 2 are dust, sweat and water resistant for non-water sports and exercise, and they are IP54 rated. AirPods (3rd generation) are sweat and water resistant for non-water sports and exercise, and they are IPX4 rated. Dust, sweat and water resistance are not permanent conditions.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item y77D1A3">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed kF4D59F">
                      <!---->
                      <div class="column large-12 yE10BD0">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue yC7B57B channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Find My with Precision Finding:</span> Find My functionality requires iOS 18 or later. Precision Finding requires a U1-equipped iPhone; availability varies by region.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item z8544DD">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed aAFFC47">
                      <!---->
                      <div class="column large-12 xA2ACAC">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue wA58448 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">App Store:</span> Apps are available on the App Store. Title availability is subject to change.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item s569B3B">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed w17852D">
                      <!---->
                      <div class="column large-12 r2D0706">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue nD3CD1A channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Conversation Awareness:</span> Available on compatible devices running iOS 18, iPadOS 18 or macOS Sequoia and later when paired with AirPods 4 with Active Noise Cancellation or AirPods Pro 2 with the latest firmware.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item u6A4089">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed w7407CB">
                      <!---->
                      <div class="column large-12 tEFF2B5">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue k7299B5 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Voice Isolation:</span> Available on compatible devices running iOS 18, iPadOS 18 or macOS Sequoia and later when paired with AirPods 4, AirPods 4 with Active Noise Cancellation or AirPods Pro 2 with the latest firmware.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item dB392F6">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed q624EDC">
                      <!---->
                      <div class="column large-12 q9EA606">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue b447D66 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Siri Interactions:</span> Available on compatible devices running iOS 18, iPadOS 18 or macOS Sequoia and later when paired with AirPods 4, AirPods 4 with Active Noise Cancellation or AirPods Pro 2 with the latest firmware.</p>
                      </div>
                    </div>
                  </li>
                  <li role="listitem" class="list-item oDC0F86">
                    <div class="row large-display-bleed medium-display-bleed small-display-bleed h38CB7B">
                      <!---->
                      <div class="column large-12 uD9F377">
                        <div>
                          <!---->
                        </div>
                        <p class="copy helvetica-neue g95A2B9 channel-custom-font-custom-12-sosumi" style="--focus-color: rgba(0, 125, 250, 0.6);"><span style="font-weight: 500;">Automatic Switching:</span> Requires an iCloud account and a compatible Apple device running the latest operating system software.</p>
                      </div>
                    </div>
                  </li>
                  
                </ul>
              </aside>
            </div>
          </div>
        </div>
        <!--END > LEGAL-->
      </div>
</section>

  <!--BEGIN > SCRIPTS:BASE -->
  <script type="text/javascript">"use strict";const reorderDOM={selectorEls:null,headerEl:null,capturedEls:null,capturedElsQuery:null,clonedEls:[],cOrder:null,cMax:null,useStatic:null,selectorElsQuery:null,staticEl:null,staticElQuery:null,addListeners(){window.addEventListener("channel:reorder-dom",e=>{if(this.useStatic=e.detail.useStatic,this.cOrder=e.detail.order,this.cMax=e.detail.max,this.updateElements(),void 0!==e.detail.selectorIndex){document.querySelectorAll(this.selectorElsQuery).item(e.detail.selectorIndex).focus()}})},updateElements(){!this.useStatic&&this.updateSelectors(),!this.useStatic&&this.updateHeadersAX(),!this.useStatic&&this.updateRows(),this.useStatic&&this.updateStatic(),this.getStatSubCopyHeight()},arrayFromNodeList(e){const t=[];return e.forEach(e=>{t.push(e)}),t},updateStatic(){this.clonedEls.forEach((e,t)=>{const i=this.capturedEls[t],r=e.cloneNode(!0),n=r.querySelector("[role=rowheader]"),s=r.querySelector("[id=hidden-columnheader]");let o=[];this.cOrder.forEach((e,t)=>{const i=`[index="${e}"]`,n=r.querySelector(i).parentElement;o.push(n)}),o.reverse().forEach((e,t)=>{e.setAttribute("added",!0),r.prepend(e)});for(let e=0;e<r.children.length;e++){const t=r.children[e];"rowheader"!==t.getAttribute("role")&&"hidden-columnheader"!==t.getAttribute("id")&&(t.style.order="unset",this.toggleVisibility(t,e<this.cMax))}s&&r.prepend(s),r.prepend(n),r.setAttribute("added",!0),i.innerHTML=r.innerHTML})},updateHeadersAX(){let e=`<div role="columnheader">${getComputedStyle(document.querySelector(".channel-compare")).getPropertyValue("--column-header-empty-cell")}</div>`;document.querySelectorAll(this.selectorElsQuery).forEach((t,i)=>{const r=t.querySelector("[selected=true]").innerText.trim();"flex"===t.parentElement.parentElement.style.display&&(e+=`<div role="columnheader">${r}</div>`)}),this.headerEl.innerHTML=e},updateSelectors(){document.querySelectorAll(this.selectorElsQuery).forEach((e,t)=>{e.replaceWith(this.selectorEls[t])}),this.cOrder.forEach((e,t)=>{const i=this.selectorEls[t];let r=0;for(let t=0;t<i.options.length;t++){const n=i.options[t],s=Number(n.value)===e;s&&(r=t),n.removeAttribute("selected"),n.setAttribute("selected",s),n.removeAttribute("aria-selected"),n.setAttribute("aria-selected",s)}i.selectedIndex=r});for(var e=0;e<this.selectorEls.length;e++){const t=this.selectorEls[e],i=e<this.cMax;this.toggleVisibility(t.parentElement.parentElement,i)}},updateRows(){this.clonedEls.forEach((e,t)=>{const i=this.capturedEls[t],r=e.cloneNode(!0),n=r.querySelector("[role=rowheader]"),s=[];this.cOrder.forEach(e=>{const t=`[index="${e}"]`,i=r.querySelector(t).parentElement;s.push(i)}),s.reverse().forEach(e=>{r.prepend(e)});for(let e=0;e<r.children.length;e++){const t=r.children[e];"rowheader"!==t.getAttribute("role")&&(t.style.order="unset",this.toggleVisibility(t,e<this.cMax))}r.prepend(n),i.innerHTML=r.innerHTML})},getStatSubCopyHeight(){let e=document.getElementsByClassName("compare-template-preview-item-stat");if(e){let t=[];Array.from(e).forEach((e,i)=>{const r=e.children;let n=[];Array.from(r).forEach(e=>{"visible"===e.style.visibility&&n.push(e.children[0].children[0])});let s=[];n.forEach(e=>{let r=[],n=0;Array.from(e.children).forEach(e=>{const s=e;s.style.height="",s.children[0].className.includes("stat-value")||s.children[0].className.includes("image")||s.children[0].className.includes("mdash")||(r.push(s),void 0===t[i]?t[i]=[s.offsetHeight]:void 0===t[i][n]?t[i][n]=s.offsetHeight:void 0!==t[i][n]&&s.offsetHeight>t[i][n]&&(t[i][n]=s.offsetHeight),n++)}),s.push(r)}),s.forEach(e=>{e.forEach((e,r)=>{e.style.height=`${t[i][r]}px`})})})}},toggleVisibility(e,t){e.style.visibility=t?"visible":"hidden",e.style.display=t?"flex":"none",e.style.order="unset"},init(e,t,i,r,n){this.useStatic=n,this.capturedEls=document.querySelectorAll(e),this.capturedElsQuery=e,this.headerEl=document.querySelector(i),this.selectorEls=document.querySelectorAll(t),this.selectorElsQuery=t,this.staticElQuery=r,this.staticEl=this.useStatic&&document.querySelector(this.staticElQuery).cloneNode(!0),this.useStatic=n,this.clonedEls=this.arrayFromNodeList(this.capturedEls),this.addListeners()}},viewportManager={nState:null,cState:null,init:function(){this.addListeners()},addListeners:function(){const e={small:window.matchMedia("(max-width: 734px)"),medium:window.matchMedia("(min-width: 735px) and (max-width: 1068px)"),large:window.matchMedia("(min-width: 1069px)")};Object.keys(e).forEach(t=>{const i=e[t];"function"!=typeof i.addEventListener?i.addListener(()=>{i.matches&&this.viewportObserve(t)}):i.addEventListener("change",()=>{i.matches&&this.viewportObserve(t)}),i.matches&&this.viewportObserve(t)})},viewportObserve:function(e){this.nState=e,this.cState!==this.nState&&(this.cState=this.nState,this.dispatch(this.cState))},dispatch:function(e){const t=new CustomEvent("channel:viewport-change",{detail:e});window.dispatchEvent(t)}},orientationManager={orienation:null,init:function(){window.matchMedia("(orientation: portrait)").addEventListener("change",e=>{e.matches?this.orienation="portrait":this.orienation="landscape",this.dispatch(this.orienation)})},dispatch:function(e){const t=new CustomEvent("channel:orientation-change",{detail:e});window.dispatchEvent(t)}},selectorManager={init:function(e,t){const i=document.querySelectorAll(e);i.forEach((e,t)=>{e.addEventListener("change",()=>{const r=e.selectedIndex,n=e.value,s=Number(e.options[r].getAttribute("value"));this.dispatch({elIndex:t,selectedIndex:s,value:n,selectorEls:i}),e.focus()})})},dispatch:function(e){const t=new CustomEvent("channel:pre-user-select",{detail:e});window.dispatchEvent(t)}},buyButtonManager={buyButtonQuery:null,init:function(e){this.buyButtonQuery=e,this.addListeners(),this.attachButtonListeners()},addListeners:function(){window.addEventListener("channel:reorder-dom",()=>{this.attachButtonListeners()})},attachButtonListeners:function(){document.querySelectorAll(this.buyButtonQuery).forEach(e=>{e.addEventListener("click",t=>{const i=0===t.screenX&&0===t.screenY?"Keyboard Interaction":"Mouse Click";this.dispatch({productName:e.id,eventSource:i})})})},dispatch:function(e){const t=new CustomEvent("channel:buy-button-click",{detail:e});window.dispatchEvent(t)}},dataManager={order:null,viewportKey:null,viewportOrder:null,viewportMax:null,init:function(e,t){this.order=e,this.useStatic=t,this.addListeners()},viewportChange(e){this.viewportKey=e,this.viewportOrder=this.order[this.viewportKey],this.viewportMax=this.order.max[this.viewportKey],this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic})},blurSelects(e){document.querySelectorAll(e).forEach(e=>{e.blur()})},flattenOrders(){this.viewportOrder=this.order[this.viewportKey],this.viewportMax=this.order.max[this.viewportKey],["small","medium","large"].forEach(e=>{this.order[e]=this.viewportOrder})},getLineupInfo(e,t){const i={};return e.forEach((e,r)=>{i[r]={columnIndex:r,deviceName:e.options[e.selectedIndex].text,hasChanged:r===t}}),i},userSelect(e){const{elIndex:t,selectedIndex:i}=e,r=this.viewportOrder[t],n=this.viewportOrder.find(e=>e===i),s=this.viewportOrder.indexOf(n);void 0!==n?(this.viewportOrder[s]=r,this.viewportOrder[t]=n):this.viewportOrder[t]=i,this.flattenOrders(),this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic,selectorIndex:t}),e.deviceLineup=this.getLineupInfo(e.selectorEls,t),delete e.selectorEls;const o=Object.keys(e.deviceLineup).slice(0,this.viewportMax).reduce((t,i)=>(t[i]=e.deviceLineup[i],t),{});this.dispatchPostUserSelect({deviceLineup:o})},addListeners:function(){window.addEventListener("channel:pre-user-select",e=>{this.userSelect(e.detail)}),window.addEventListener("channel:user-refresh",e=>{this.dispatch({order:this.viewportOrder,max:this.viewportMax,useStatic:this.useStatic})}),window.addEventListener("channel:viewport-change",e=>{this.viewportChange(e.detail),this.blurSelects(this.selectorElsQuery)}),window.addEventListener("change:orientation-change",()=>{this.blurSelects(this.selectorElsQuery)})},dispatch:function(e){const t=new CustomEvent("channel:reorder-dom",{detail:e});window.dispatchEvent(t)},dispatchPostUserSelect:function(e){const t=new CustomEvent("channel:user-select",{detail:e});window.dispatchEvent(t)}},channelCompare={inited:!1,init:function(e=null){if(this.inited)return;let t;if(this.isDev=window.location.host.indexOf("127.0.0.1")>-1,e)t=e;else if(!e){const e=document.querySelector("[data-channel-html-compare]");if(!e)return void console.warn("channelCompare: element[data-channel-html-compare not found]");try{const i=e.getAttribute("data-channel-html-compare");t=JSON.parse(i)}catch(e){return void console.warn("channelCompare: error parsing JSON",e)}}if(t.isConfigurableCompare){let e={large:[],medium:[],small:[]},i=[];const r=document.querySelector("[data-compare-lineup]");if(r)try{const e=r.getAttribute("data-compare-lineup"),t=JSON.parse(null!==e&&void 0!==e?e:"{}");t["apple-compare"]&&(i=t["apple-compare"])}catch(e){return void console.warn("channelCompare: error parsing JSON",e)}const n=new URL(window.location.toLocaleString()).searchParams;n.get("apple-compare")&&(i=n.get("apple-compare").split(",")),Object.keys(e).forEach(t=>{var r;e[t]=[...new Set(null!==(r=null===i||void 0===i?void 0:i.map(e=>Number(e)-1))&&void 0!==r?r:[])].filter(e=>Number(e)>=0)}),t.order=this.orderOverwrite(t.order,e)}const i=t.order,r=t.headerEl,n=t.selectorEls,s=t.swapEls,o=t.staticEl,a=t.useStatic;reorderDOM.init(s,n,r,o,a),!a&&selectorManager.init(n),buyButtonManager.init(".compare-button"),dataManager.init(i,a),viewportManager.init(),orientationManager.init(),this.inited=!0},orderOverwrite:function(e,t){const i=Object.assign({},e);return Object.keys(t).forEach(e=>{const r=i[e].filter(i=>!t[e].includes(i)),n=[...t[e],...r].slice(0,5);i[e]=n}),i}};window.addEventListener("pageshow",e=>{const{persisted:t}=e;if(t)window.addEventListener("scroll",()=>{const e=new CustomEvent("channel:user-refresh");window.dispatchEvent(e)},{once:!0});else{channelCompare.init(),document.querySelector(".channel-compare").classList.remove("channel-compare--hidden")}});</script>
  <!--END > SCRIPTS:BASE -->